import api from "app/lib/api";
import { EXCEL_CONTENT_TYPE } from "static/constants";
import endpoints from "static/endpoints";

export const getTransmissionReportLogsByUserId = async (userId) => {
  const url = `${endpoints.userActivityLog.transmissionReportLogByUserId}/${userId}`;

  const { data, headers } = await api.get(url, {
    responseType: "blob",
  });

  const contentType = headers?.get("Content-Type");
  if (contentType !== EXCEL_CONTENT_TYPE) {
    const jsonData = JSON.parse(await data.text());
    return { ...jsonData };
  }
  const fileHeader = headers?.get("Content-Disposition");
  const filename = fileHeader?.split("filename=")[1];
  return { data, filename };
};

export const getTransmissionProgressReportByUserId = async (userId) => {
  const url = `${endpoints.userActivityLog.transmissionProgressReportByUserId}/${userId}`;
  return await api.get(url);
};

export const getTopTransmissionProgressReport = async () => {
  const url = `${endpoints.userActivityLog.topUserProgressReport}`;
  return await api.get(url);
};

export const getUserTransmissionProgressAnalytics = async (filter) => {
  let url = endpoints.userActivityLog.userTransmissionProgressAnalytics;

  const queryParams = Object.entries(filter)
    .filter(([_, value]) => value)
    .map(([key, value]) => `${key}=${value}`);

  if (queryParams.length > 0) {
    url += `?${queryParams.join("&")}`;
  }

  const { data } = await api.get(url);
  return data;
};

export const getUserTransmissionProgressReport = async (payload) => {
  const url = endpoints.userActivityLog.userTransmissionProgressReport;

  const { data, headers } = await api.post(url, payload, {
    responseType: "blob",
  });

  const contentType = headers?.get("Content-Type");
  if (contentType !== EXCEL_CONTENT_TYPE) {
    const jsonData = JSON.parse(await data.text());
    return { ...jsonData };
  }
  const fileHeader = headers?.get("Content-Disposition");
  const filename = fileHeader?.split("filename=")[1];
  return { data, filename };
};

export const getTransmissionProgressAnalyticsUsers = async () => {
  let url = endpoints.userActivityLog.transmissionProgressAnalyticsUsers;
  const { data } = await api.get(url);
  return data;
};
